import React from 'react';
import { Input } from '@chakra-ui/react';
import { Checkbox } from '../code-bench-panel/lookup/result-row';
import { objectUtils } from '@codametrix/ui-common';
import './styles/index.scss';
const { isEmpty, cloneDeep } = objectUtils;

export type AutocompleteMultiSelectProps = {
    currentFilter: string | null;
    filterSelection: CMxCommonApp.FilterSelection;
    filterData: CMxCommonApp.SharedFilter[];
    defaultFilterSelection: CMxCommonApp.FilterSelection;
    handleExcludeAndInclude: (checked: boolean) => void;
    handleSearchInputChange: (searchQuery: string) => void;
    handleCheckboxClick: (key: string) => void;
    searchQuery: string;
};

class AutocompleteMultiSelect extends React.Component<
    AutocompleteMultiSelectProps
> {

    constructor(props: AutocompleteMultiSelectProps) {
        super(props);

        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    }

    handleSearchInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleSearchInputChange(event.target.value);
    }

    render() {
        const { searchQuery } = this.props;
        const { currentFilter, filterData, filterSelection, handleExcludeAndInclude, handleCheckboxClick } = this.props;
        let currentFilterOptions = filterData?.find(
            ({ type }) => type === currentFilter
        )?.filterOptions;

        let defaults = filterSelection?.[currentFilter]
            ? cloneDeep(filterSelection?.[currentFilter])
            : {};

        if (!isEmpty(searchQuery) && currentFilterOptions?.length) {
            currentFilterOptions = currentFilterOptions?.filter(item =>
                item?.key?.toLowerCase().includes(searchQuery?.toLowerCase())
            );
            const searchMatchKeys = currentFilterOptions?.map(obj => String(obj?.key));
            
            defaults = Object.fromEntries(Object.entries(defaults).filter(([key]) => searchMatchKeys.some(
                matchKey => matchKey.toLowerCase() === key.toLowerCase()
            )))
        }

        return (

            <div className="filter-content multi-select-filter-content">
                <Input
                    placeholder="Find event type..."
                    className="filter-search"
                    value={searchQuery}
                    onChange={this.handleSearchInputChange}
                    mb={4}
                />
                <div className="options-selection">
                    <button
                        onClick={e => handleExcludeAndInclude(true)}
                        key="options-selection-include">
                        Include all
                    </button>
                    <button
                        onClick={e => handleExcludeAndInclude(false)}
                        key="options-selection-exclude">
                        Exclude all
                    </button>
                </div>
                <div className="check-list">
                    {currentFilterOptions.map(({ key, name }) => (
                        <div className="check-box-row" key={key}>
                            <Checkbox
                                value={defaults[key]}
                                label={name}
                                onChange={() => handleCheckboxClick(key)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}

export { AutocompleteMultiSelect };
